import React from 'react';
import { Link } from 'react-router-dom';

import { Avatar, Box, Snackbar, Typography } from '@mui/material';

import { VennueAccessRequestItem } from '../../graphql/API';

type Props = {
  accessRequest: VennueAccessRequestItem | null;
  open: boolean;
  onClose: () => void;
};

export const AccessRequestAlert: React.FC<Props> = ({ accessRequest, open, onClose }) => {
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={() => onClose}>
      <Box
        sx={{
          borderRadius: '8px',
          backgroundColor: '#DDF4E8',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Avatar
          sx={{ width: 34, height: 34 }}
          variant='circular'
          alt={accessRequest?.user?.firstname}
          src={String(accessRequest?.user?.picture?.medium)}
        />
        <Typography fontSize={'15px'} fontWeight={'400'}>
          You have accepted{' '}
          <b>
            {accessRequest?.user?.firstname} {accessRequest?.user?.lastname}
          </b>{' '}
          request, you can now track her reservation{' '}
          <Link to='/reservations' style={{ fontWeight: 700, color: '#111' }}>
            here
          </Link>
        </Typography>
      </Box>
    </Snackbar>
  );
};

export const BulkAccessRequestAlert: React.FC<Omit<Props, 'accessRequest'>> = ({ open, onClose }) => {
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={() => onClose}>
      <Box
        sx={{
          borderRadius: '8px',
          backgroundColor: '#DDF4E8',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <Typography fontSize={'15px'} fontWeight={'400'}>
          You have accepted request, you can now track her reservation{' '}
          <Link to='/reservations' style={{ fontWeight: 700, color: '#111' }}>
            here
          </Link>
        </Typography>
      </Box>
    </Snackbar>
  );
};
